export const freePlanPrice = 24;